import { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { observer } from "mobx-react";
import {Link, useParams} from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import Pagination from 'react-bootstrap/Pagination';
import Buscador from "./Buscador";
import CategoriasSide from "./CategoriasSide";
import CategoriasBreadcrumbs from "./CategoriasBreadcrumbs";
import Producto from "./Producto";
import productosStore from "../stores/ProductosStore";
import Loading from "./Loading";
import { NoIVA } from "./Footer";
import usuariosStore from "../stores/UsuariosStore";
import ScrollToTop from "../utils/ScrollToTop";
import globals from "../globals";

function Catalogo(props) {
    const { query, catId, familia } = useParams();
    const { /*scroll = true,*/ simple, resXpag = 9, titulo, novedades } = props;
    const [state, setState] = useState({
        page: 0,
        pages: 0,
        runningPage: 0,
        productos: [],
        currentCatId: undefined,
        family: undefined,
        currentNovedades: novedades,
        cache: {},
        cargando: false
    });

    const listar = (page) => {
        setState({cargando: true});
        productosStore.setCargando(true);
        if (page !== 0 && page > state.pages) return;
        /*
        if (state.runningPage === state.page + 1) return;
        if (state.page !== 0 && state.page === state.pages) return;
         */
        // Para que no sea un scroll infinito y tenga paginacion
        window.scrollTo(0, 0);
        setState({ productos: [] });
        productosStore.listarProductos(
            novedades ? undefined : state.currentCatId,
            novedades ? undefined : state.family,
            novedades ? undefined : query,
            page,
            //state.page + 1,
            resXpag,
            novedades ? 'C' : 'A',
            novedades ? 'DESC' : 'ASC',
        //    novedades ? '' : undefined
        ).then(() => {
            if (!productosStore.errorListando) {
                setState({
                    page: productosStore.productos.page,
                    pages: productosStore.productos.pages,
                    runningPage: state.page + 1,
                    //productos: state.productos.concat(productosStore.productos.data),
                    productos: productosStore.productos.data,
                    currentCatId: state.currentCatId,
                    family: state.family,
                    currentNovedades: novedades,
                    cargando: false
                });
            }
        });
    };

    const BotonCargarMas = () => {
        let items = [];
        // Vuelve 1
        if (state.page > 1) {
            items.push(
                <Pagination.Item key={'primero'} onClick={() => listar(1)}>
                    <i className="fa-solid fa-angle-double-left"></i>
                </Pagination.Item>
            );
            items.push(
                <Pagination.Item key={'unomenos'} onClick={() => listar(state.page - 1)}>
                    <i className="fa-solid fa-angle-left"></i>
                </Pagination.Item>
            );
        }

        const pags = isMobile ? 3 : 6;
        let resto = pags;
        if (state.page < pags + 1)
            resto += pags + 1 - state.page;
        for (
            let n = Math.max(1, state.page - pags);
            n <= Math.min(state.page + resto, state.pages);
            n++
        ) {
            items.push(
                <Pagination.Item key={n} active={n === state.page} onClick={() => listar(n)}> {n} </Pagination.Item>
            );
        }
        if (state.page < state.pages) {
            items.push(
                <Pagination.Item key={'unomas'} onClick={() => listar(state.page + 1)}>
                    <i className="fa-solid fa-angle-right"></i>
                </Pagination.Item>
            );
            items.push(
                <Pagination.Item key={'ultimo'} onClick={() => listar(state.pages)}>
                    <i className="fa-solid fa-angle-double-right"></i>
                </Pagination.Item>
            );
        }

        return (
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 cargar-mas">
                {false && state.page > 0 && state.pages > 0 && <div> Pagina {state.page} de {state.pages} </div> }
                {false && <button onClick={() => listar()}> Cargar Mas Productos </button>}
                <Pagination> {items} </Pagination>
            </div>
        )
    }

    useEffect(() => {
        if (
            catId !== state.currentCatId ||
            familia !== state.family ||
            novedades !== state.currentNovedades
        ) {
            setState({
                page: 0,
                pages: 0,
                runningPage: 0,
                productos: [],
                currentCatId: catId,
                family: familia,
                currentNovedades: novedades,
                cargando: true
            });
        }
        if (!productosStore.errorListando && state.page === 0) {
            productosStore.setCargando(true);
            listar();
        }
        /*
        const handleScroll = (e) => {
            if (!scroll) return;
            const scrollHeight = e.target.documentElement.scrollHeight;
            const currentHeight = e.target.documentElement.scrollTop + window.innerHeight;
            if (currentHeight + 300 >= scrollHeight) {
                listar();
            }
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
         */
    });

    const loadingCSS = {
        height: '100px',
        margin: '100px',
        display: state.cargando ? "block" : "none"
        //display: productosStore.cargando ? "block" : "none"
    };

    if (productosStore.errorListandoNoAbort) {
        return (
            <div style={{marginTop: '140px'}}>
                <div className="row">
                    <div className="col-12 text-center mb-3 ">
                        <h3 className="bold">
                            El sitio se encuentra en mantenimiento.<br /><br />
                        </h3>
                        <h3>
                            Sepa disculpar las molestias, <br /> estaremos online a la brevedad.
                        </h3>
                    </div>
                </div>
            </div>
        )
    }

    if (simple) {
        return (
            <div>
                <div className="row">
                    <div className="col-12 text-center mb-3 ">
                        <h3 className="bold">{titulo}</h3>
                        {/*
                        <h5 className="titulo-link"><Link to={'/catalogo'}>VER EL CATÁLOGO COMPLETO</Link></h5>
                        */}
                    </div>
                </div>
                <div className="row d-flex justify-content-center">
                    {/* !productosStore.cargando && state.productos.length === 0 && */}
                    { /*!state.cargando && state.productos.length === 0 &&
                        <span>No hay productos para mostrar.</span>
                    */}
                    { state.productos.map(prod =>
                        <Producto prod={prod} key={prod.id} wide />
                    )}
                </div>
                <div style={loadingCSS}> <Loading /> </div>
                <NoIVA />
            </div>
        )
    }

    return (
        <div className="container-fluid px-0 mx-0" id="catalogo">
            <ScrollToTop />
            <div className="container">
                <div className="row d-flex justify-content-center">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 bc-bg">
                        <CategoriasBreadcrumbs novedades={novedades} />
                    </div>
                    <div className="col-xl-2 col-lg-3 col-md-12 col-sm-12 col-12">
                        <CategoriasSide novedades={novedades} />
                    </div>
                    <div className="col-xl-10 col-lg-9 col-md-12 col-sm-12 col-12 lista-productos">
                        <Buscador />
                        <div className="row listado-angosto">
                            {/* !productosStore.cargando && state.productos.length === 0 && */}
                            {/* !state.cargando && state.productos.length === 0 &&
                                <span>No hay productos para mostrar.</span>
                            */}
                            { state.productos.map(prod =>
                                <Producto prod={prod} key={prod.id} wide={true} />
                            )}
                        </div>

                        <div style={loadingCSS}> <Loading /> </div>
                        <BotonCargarMas />
                    </div>
                </div>
            </div>
            <NoIVA />
        </div>
    );
}
export default observer(Catalogo);
